import store from '../store'
var headers = () => {
  return { headers: { token: store.state.user.jwt, app: 'PCON' } }
}
export default headers
